const tokens = {
    token: {
        key: 'token'
    },
    accessToken: {
        key: 'accessToken'
    },
    refreshToken: {
        key: 'refreshToken'
    }
}

export default tokens
